module.exports = __webpack_public_path__ + "img/cryptocurrency-600x450.82530f3b.jpg";